import { useCallback, useState } from 'react';
import { Toast } from 'antd-mobile';
import { CSSTransition } from 'react-transition-group';
import { useMounted, useUnmount } from '@/utils/hooks';
import { fixedBody, looseBody } from '@/utils/fn';
import { jsHandleShare } from '@/utils/bridge';
import styles from './index.less';

const CommunityModal = ({
  handleClose,
  onSaveQRcode,
  title = 'x86尊享交流群',
  qrcode = '',
  comefrom = '',
  desc = '微信扫码加群\n技术大牛给你指引',
}) => {
  console.log('qrcode: ', qrcode);
  const [inProp, setInProp] = useState(false);

  const saveQRCodeCallback = useCallback(
    res => {
      if (res.code === 0) {
        Toast.info('保存成功');
      }
      if (onSaveQRcode) {
        onSaveQRcode();
      } else {
        if (res.code !== 0) Toast.info('保存失败，请检查权限或升级App后重试');
      }
      handleClose();
    },
    [handleClose, onSaveQRcode]
  );

  const handleSaveQRCode = useCallback(() => {
    jsHandleShare(
      {
        share_item: {
          platform: 6,
          share_image: `${window.location.origin}${qrcode}`,
        },
      },
      saveQRCodeCallback
    );
  }, [qrcode, saveQRCodeCallback]);

  useMounted(() => {
    fixedBody();
    setTimeout(() => setInProp(true), 200);
  });

  useUnmount(() => {
    looseBody();
  });
  return (
    <div className={styles.modal} onClick={handleClose}>
      <CSSTransition in={inProp} timeout={200} classNames="fade" mountOnEnter unmountOnExit>
        <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
          <h3 className={styles.title}>- {title} -</h3>
          <div className={styles.qrCode}>
            <img src={qrcode} alt="社群二维码" />
          </div>
          {/* <p className={styles.serviceText}>
            微信扫码加群
            <br />
            技术大牛给你指引
          </p> */}
          {desc && <p className={styles.serviceText}>{desc}</p>}
          {comefrom === 'miniprogram' ? (
            <button>长按添加</button>
          ) : (
            <button onClick={handleSaveQRCode}>保存到相册</button>
          )}
        </div>
      </CSSTransition>
    </div>
  );
};
export default CommunityModal;
